
import {
  schema, normalize
} from 'normalizr';

// Define answer schema
const categorySchema = new schema.Entity('categories')
const lareaSchema = new schema.Entity('lareas', {
  categories: [categorySchema]
})
const lareaListSchema = [lareaSchema]

export function adaptLAreasToStore({data}) {
  const entries = normalize(data.results, lareaListSchema)

  return {
    entries: entries.entities,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results
  }
}